import { IStepOption } from 'ngx-ui-tour-md-menu';

/**
 * Global default step options for the onboarding tour.
 * ngx-ui-tour v17 removed TourService.setDefaults — defaults are now passed
 * to provideUiTour() (global) or TourService.initialize(steps, defaults) (per tour).
 */
export const TOUR_STEP_DEFAULTS: IStepOption = {
  asyncStepTimeout: 5000,
  backdropConfig: { offset: 5, backgroundColor: 'rgba(45, 57, 64, 0.3)' },
  enableBackdrop: true,
  isAsync: true,
  scrollContainer: '.content-wrapper',
  stepDimensions: { width: 'auto', maxWidth: '400px' },
  prevBtnTitle: 'Back',
  smoothScroll: true,
  delayBeforeStepShow: 500,
  delayAfterNavigation: 1000,
  duplicateAnchorHandling: 'registerFirst',
  // @TODO position breaks on scroll
  // centerAnchorOnScroll: false,
  // disablePageScrolling: true,
  // disableScrollToAnchor: true,
  // showProgress: false,
  // isOptional
  // nextOnAnchorClick: true,
  // closeOnOutsideClick: true
  // allowUserInitiatedNavigation
};
